// Données complètes Gouvernance du Comité TI
// Méthodologie RACI, structure équipes, guide pédagogique

export interface MembreEquipe {
  id: string;
  nom: string;
  prenom: string;
  initiales: string;
  titre: string;
  email: string;
  role: 'Client' | 'Chargé Projet' | 'Prime' | 'Directeur Compte' | 'Spécialiste';
  badgeLabel: string;
  badgeColor: string;
  competenceScore: number;
  equipe: 'Stratégia Corp' | 'BZ';
}

export interface ActiviteRACI {
  id: string;
  nom: string;
  niveau: 'Stratégique' | 'Tactique' | 'Opérationnel';
  client: 'R' | 'A' | 'C' | 'I';
  chargéProjet: 'R' | 'A' | 'C' | 'I';
  prime: 'R' | 'A' | 'C' | 'I';
  dirCompte: 'R' | 'A' | 'C' | 'I';
  spécialistes: 'R' | 'A' | 'C' | 'I';
}

export interface ExempleConcret {
  titre: string;
  situation: string;
  roles: {
    lettre: 'A' | 'R' | 'C' | 'I';
    personne: string;
    titre: string;
    actions: string[];
    couleur: string;
  }[];
  resultat: string;
}

export interface PiegeRaci {
  titre: string;
  description: string;
  solution: string;
  icone: string;
}

// ============================================
// ÉQUIPES - Stratégia Corp & BZ
// ============================================

export const equipeStrategia: MembreEquipe[] = [
  {
    id: 'serq-1',
    nom: 'Bolduc',
    prenom: 'Sophie',
    initiales: 'SB',
    titre: 'Directrice Générale',
    email: 'sophie.bolduc@strategiacorp.com',
    role: 'Client',
    badgeLabel: 'Client (Décisionnaire)',
    badgeColor: 'bg-blue-500',
    competenceScore: 90,
    equipe: 'Stratégia Corp'
  }
];

export const equipeBZ: MembreEquipe[] = [
  {
    id: 'bz-0',
    nom: 'Moreau',
    prenom: 'Dany',
    initiales: 'YM',
    titre: 'Vice-Président Stratégie',
    email: 'dany.bourassa@bzinc.ca',
    role: 'Chargé Projet',
    badgeLabel: 'CA/CE - Visionnaire',
    badgeColor: 'bg-gradient-to-r from-amber-500 to-orange-600',
    competenceScore: 98,
    equipe: 'BZ'
  },
  {
    id: 'bz-1',
    nom: 'Bourassa',
    prenom: 'Dany',
    initiales: 'DB',
    titre: 'Président - Architecte PRIsME',
    email: 'dany.bourassa@bzinc.ca',
    role: 'Spécialiste',
    badgeLabel: 'Président - Créateur',
    badgeColor: 'bg-gradient-to-r from-purple-600 to-pink-600',
    competenceScore: 95,
    equipe: 'BZ'
  },
  {
    id: 'bz-1b',
    nom: 'Delisle',
    prenom: 'François',
    initiales: 'FD',
    titre: 'Vice-Président Technologies',
    email: 'francois.delisle@bzinc.ca',
    role: 'Prime',
    badgeLabel: 'VP Techno - Architecte',
    badgeColor: 'bg-gradient-to-r from-blue-500 to-cyan-600',
    competenceScore: 97,
    equipe: 'BZ'
  },
  {
    id: 'bz-2',
    nom: 'Durand',
    prenom: 'Eric',
    initiales: 'ED',
    titre: 'Directeur de programmation',
    email: 'eric.durand@bzinc.ca',
    role: 'Spécialiste',
    badgeLabel: 'Spécialiste BZ',
    badgeColor: 'bg-purple-500',
    competenceScore: 92,
    equipe: 'BZ'
  },
  {
    id: 'bz-3',
    nom: 'Fortin',
    prenom: 'Pierre-Luc',
    initiales: 'PF',
    titre: 'Directeur de compte',
    email: 'pierre-luc.fortin@bzinc.ca',
    role: 'Directeur Compte',
    badgeLabel: 'Directeur de Compte BZ',
    badgeColor: 'bg-orange-500',
    competenceScore: 88,
    equipe: 'BZ'
  },
  {
    id: 'bz-4',
    nom: 'Gariepy',
    prenom: 'Maxime',
    initiales: 'MG',
    titre: 'Prime / Spécialiste Technique',
    email: 'maxime.gariepy@bzinc.ca',
    role: 'Prime',
    badgeLabel: 'Prime BZ',
    badgeColor: 'bg-pink-500',
    competenceScore: 93,
    equipe: 'BZ'
  },
  {
    id: 'bz-5',
    nom: 'Hains',
    prenom: 'Eric',
    initiales: 'EH',
    titre: 'Directeur TI / Chargé de projet',
    email: 'eric.hains@bzinc.ca',
    role: 'Chargé Projet',
    badgeLabel: 'Chargé de Projet BZ',
    badgeColor: 'bg-blue-600',
    competenceScore: 89,
    equipe: 'BZ'
  },
  {
    id: 'bz-6',
    nom: 'Leclerc',
    prenom: 'Jean-Pierre',
    initiales: 'JL',
    titre: 'Directeur Service TI',
    email: 'jean-pierre.leclerc@bzinc.ca',
    role: 'Spécialiste',
    badgeLabel: 'Spécialiste BZ',
    badgeColor: 'bg-purple-500',
    competenceScore: 90,
    equipe: 'BZ'
  },
  {
    id: 'bz-7',
    nom: 'Marquis',
    prenom: 'Francis',
    initiales: 'FM',
    titre: 'Directeur Solution d\'affaires et Cybersécurité',
    email: 'francis.marquis@bzinc.ca',
    role: 'Spécialiste',
    badgeLabel: 'Spécialiste BZ',
    badgeColor: 'bg-purple-500',
    competenceScore: 91,
    equipe: 'BZ'
  }
];

// ============================================
// MATRICE RACI COMPLÈTE
// ============================================

export const activitesRACI: ActiviteRACI[] = [
  // ========== STRATÉGIQUE ==========
  {
    id: 'strat-1',
    nom: 'Définition vision TI annuelle',
    niveau: 'Stratégique',
    client: 'A',
    chargéProjet: 'C',
    prime: 'C',
    dirCompte: 'C',
    spécialistes: 'I'
  },
  {
    id: 'strat-2',
    nom: 'Approbation budget TI',
    niveau: 'Stratégique',
    client: 'A',
    chargéProjet: 'C',
    prime: 'C',
    dirCompte: 'C',
    spécialistes: 'I'
  },
  {
    id: 'strat-3',
    nom: 'Choix fournisseurs majeurs',
    niveau: 'Stratégique',
    client: 'A',
    chargéProjet: 'R',
    prime: 'C',
    dirCompte: 'I',
    spécialistes: 'C'
  },
  {
    id: 'strat-4',
    nom: 'Décision investissements >50K$',
    niveau: 'Stratégique',
    client: 'A',
    chargéProjet: 'C',
    prime: 'C',
    dirCompte: 'C',
    spécialistes: 'I'
  },
  // ========== TACTIQUE ==========
  {
    id: 'tact-1',
    nom: 'Planification projets trimestriels',
    niveau: 'Tactique',
    client: 'A',
    chargéProjet: 'R',
    prime: 'C',
    dirCompte: 'I',
    spécialistes: 'C'
  },
  {
    id: 'tact-2',
    nom: 'Priorisation des demandes',
    niveau: 'Tactique',
    client: 'A',
    chargéProjet: 'R',
    prime: 'C',
    dirCompte: 'I',
    spécialistes: 'C'
  },
  {
    id: 'tact-3',
    nom: 'Gestion des risques',
    niveau: 'Tactique',
    client: 'A',
    chargéProjet: 'R',
    prime: 'C',
    dirCompte: 'I',
    spécialistes: 'C'
  },
  {
    id: 'tact-4',
    nom: 'Revue performance mensuelle',
    niveau: 'Tactique',
    client: 'A',
    chargéProjet: 'R',
    prime: 'C',
    dirCompte: 'C',
    spécialistes: 'I'
  },
  // ========== OPÉRATIONNEL ==========
  {
    id: 'oper-1',
    nom: 'Exécution projets TI',
    niveau: 'Opérationnel',
    client: 'I',
    chargéProjet: 'A',
    prime: 'C',
    dirCompte: 'I',
    spécialistes: 'R'
  },
  {
    id: 'oper-2',
    nom: 'Support technique quotidien',
    niveau: 'Opérationnel',
    client: 'I',
    chargéProjet: 'A',
    prime: 'C',
    dirCompte: 'I',
    spécialistes: 'R'
  },
  {
    id: 'oper-3',
    nom: 'Maintenance infrastructure',
    niveau: 'Opérationnel',
    client: 'I',
    chargéProjet: 'A',
    prime: 'C',
    dirCompte: 'I',
    spécialistes: 'R'
  },
  {
    id: 'oper-4',
    nom: 'Formation utilisateurs',
    niveau: 'Opérationnel',
    client: 'C',
    chargéProjet: 'A',
    prime: 'C',
    dirCompte: 'I',
    spécialistes: 'R'
  }
];

// ============================================
// PHILOSOPHIE DE GOUVERNANCE
// ============================================

export const philosophieGouvernance = [
  {
    id: 'philo-1',
    titre: 'Transparence Totale',
    description: 'Vous savez toujours qui fait quoi, qui décide, et pourquoi. Aucune zone grise.',
    icone: 'CheckCircle',
    couleur: 'text-green-600 bg-green-50'
  },
  {
    id: 'philo-2',
    titre: 'Autonomie Client',
    description: 'VOUS décidez. Nous vous outillons avec les meilleures informations pour choisir.',
    icone: 'Target',
    couleur: 'text-blue-600 bg-blue-50'
  },
  {
    id: 'philo-3',
    titre: 'Rythme sur Mesure',
    description: 'Vos technologies évoluent selon VOS priorités et VOTRE budget. Aucune pression.',
    icone: 'TrendingUp',
    couleur: 'text-purple-600 bg-purple-50'
  }
];

// ============================================
// STATISTIQUES GOUVERNANCE
// ============================================

export const statsGouvernance = {
  partiesPrenantes: 8,
  membresStrategia: 1,
  expertsBZ: 7,
  methodeRACI: 'Standard'
};

// ============================================
// EXEMPLE CONCRET PÉDAGOGIQUE
// ============================================

export const exempleConcret: ExempleConcret = {
  titre: 'Choix d\'un nouveau système',
  situation: 'Stratégia Corp veut remplacer son système de gestion des membres vieillissant. Budget estimé: 75,000$.',
  roles: [
    {
      lettre: 'A',
      personne: 'Sophie',
      titre: 'Client Stratégia Corp',
      couleur: 'green',
      actions: [
        'Décide quel système choisir après avoir reçu les recommandations',
        'Approuve le budget final'
      ]
    },
    {
      lettre: 'R',
      personne: 'Eric H.',
      titre: 'Chargé Projet BZ',
      couleur: 'blue',
      actions: [
        'Fait l\'analyse de marché',
        'Prépare la comparaison des solutions',
        'Gère l\'implémentation une fois approuvé'
      ]
    },
    {
      lettre: 'C',
      personne: 'Maxime',
      titre: 'Prime BZ',
      couleur: 'orange',
      actions: [
        'Conseille sur les aspects techniques',
        'Évalue la complexité d\'intégration',
        'Recommande les meilleures pratiques'
      ]
    },
    {
      lettre: 'I',
      personne: 'Pierre-Luc',
      titre: 'Dir. Compte BZ',
      couleur: 'purple',
      actions: [
        'Informé de la décision pour prévoir le renouvellement',
        'Suit la satisfaction client'
      ]
    }
  ],
  resultat: 'Sophie a toute l\'information nécessaire pour choisir EN TOUTE CONFIANCE, sans pression. Elle garde le contrôle, BZ exécute avec excellence.'
};

// ============================================
// PIÈGES À ÉVITER
// ============================================

export const piegesRACI: PiegeRaci[] = [
  {
    titre: 'Plusieurs "A" (Accountable)',
    description: 'Si 2 personnes sont "Accountable", qui décide vraiment? Cela crée des conflits et des délais.',
    solution: '→ Solution: UN SEUL "A" par activité!',
    icone: 'AlertTriangle'
  },
  {
    titre: 'Aucun "A"',
    description: 'Personne n\'assume la responsabilité finale = décisions qui traînent ou ne se prennent jamais.',
    solution: '→ Solution: Identifier clairement le décideur!',
    icone: 'AlertTriangle'
  },
  {
    titre: 'Trop de "C" (Consulted)',
    description: 'Si tout le monde doit être consulté, rien n\'avance. Gardez les consultations essentielles seulement.',
    solution: '→ Solution: Limiter les "C" aux vrais experts!',
    icone: 'AlertTriangle'
  }
];

// ============================================
// NOTRE ENGAGEMENT
// ============================================

export const engagementBZ = [
  'Nous respectons TOUJOURS votre pouvoir décisionnel',
  'Nous vous donnons les meilleures recommandations, sans pression commerciale',
  'Nous exécutons vos décisions avec excellence et transparence',
  'Nous suivons le rythme QUE VOUS choisissez, selon VOS priorités'
];

// ============================================
// BÉNÉFICES RACI
// ============================================

export const beneficesRACI = [
  {
    titre: 'Clarté totale',
    description: 'Vous savez toujours qui décide quoi',
    icone: 'CheckCircle'
  },
  {
    titre: 'Autonomie',
    description: 'Vous gardez le contrôle sur VOS décisions stratégiques',
    icone: 'CheckCircle'
  },
  {
    titre: 'Efficacité',
    description: 'Pas de délais causés par des "Qui doit approuver?"',
    icone: 'CheckCircle'
  },
  {
    titre: 'Confiance',
    description: 'Transparence totale = relation de confiance durable',
    icone: 'CheckCircle'
  }
];

// ============================================
// RÔLES VISIONNAIRES PRIsME - TOP 3 LEADERSHIP
// ============================================

export interface RoleVisionnaire {
  id: string;
  nom: string;
  titre: string;
  rolePRIsME: string;
  vision: string;
  responsabilites: string[];
  impact: string;
  couleurGradient: string;
  icone: string;
  competences: string[];
  philosophie: string;
}

export const rolesVisionnairesPRIsME: RoleVisionnaire[] = [
  {
    id: 'vision-1',
    nom: 'Dany Bourassa',
    titre: 'Président',
    rolePRIsME: 'Architecte & Créateur d\'PRIsME',
    vision: 'Transformer l\'industrie TI en fusionnant l\'intelligence artificielle avec l\'excellence opérationnelle. Créer des outils qui changent la game.',
    responsabilites: [
      'Vision stratégique et innovation PRIsME',
      'Architecture des solutions et méthodologies',
      'Développement des concepts et frameworks',
      'Leadership créatif et direction artistique',
      'Évangélisation et démonstration de la valeur'
    ],
    impact: 'Le CRÉATEUR. Il voit ce qui n\'existe pas encore et le fait exister. PRIsME est né de sa vision en 10 jours.',
    couleurGradient: 'from-purple-600 via-pink-600 to-purple-600',
    icone: 'Sparkles',
    competences: ['Innovation IA', 'Vision Stratégique', 'Design Thinking', 'Leadership Créatif'],
    philosophie: 'L\'impossible n\'existe pas. Seules les limites qu\'on s\'impose sont réelles. PRIsME prouve que 10 jours suffisent pour changer l\'industrie.'
  },
  {
    id: 'vision-2',
    nom: 'Dany Bourassa',
    titre: 'Vice-Président Stratégie',
    rolePRIsME: 'Visionnaire Business & Stratégie de Croissance',
    vision: 'Bâtir une machine de croissance scalable. Transformer PRIsME d\'un outil brillant en empire commercial. Conquérir le marché avec méthode et rigueur.',
    responsabilites: [
      'Stratégie commerciale et positionnement marché',
      'Développement du modèle d\'affaires PRIsME',
      'Expansion et acquisition de clients (objectif: 20-25 clients)',
      'Gouvernance financière et optimisation ROI',
      'Structuration des processus de vente et delivery',
      'Partenariats stratégiques et alliances'
    ],
    impact: 'Le BÂTISSEUR D\'EMPIRE. Il prend la vision créative et la transforme en machine rentable et scalable. Sans lui, PRIsME reste un concept. Avec lui, ça devient une révolution commerciale.',
    couleurGradient: 'from-amber-500 via-orange-600 to-red-600',
    icone: 'TrendingUp',
    competences: ['Stratégie d\'Affaires', 'Croissance & Scaling', 'Gouvernance Financière', 'Leadership Opérationnel'],
    philosophie: 'La vision sans exécution est une hallucination. La créativité sans structure est du chaos. Je transforme le génie en résultats mesurables et en profits durables.'
  },
  {
    id: 'vision-3',
    nom: 'François Delisle',
    titre: 'Vice-Président Technologies',
    rolePRIsME: 'Architecte Technique & Gardien de l\'Excellence',
    vision: 'Garantir que chaque ligne de code, chaque système, chaque solution PRIsME respecte les plus hauts standards de l\'industrie. L\'excellence technique n\'est pas négociable.',
    responsabilites: [
      'Architecture technique et choix technologiques',
      'Standards de qualité et best practices',
      'Sécurité, performance et scalabilité',
      'Leadership des équipes techniques',
      'Veille technologique et innovation continue',
      'Validation et approbation des livrables techniques'
    ],
    impact: 'Le GARDIEN DE L\'EXCELLENCE. Il s\'assure que la magie d\'PRIsME repose sur des fondations solides comme le roc. Il transforme l\'innovation en solutions industrielles fiables.',
    couleurGradient: 'from-blue-500 via-cyan-600 to-blue-700',
    icone: 'Shield',
    competences: ['Architecture Technique', 'Cybersécurité', 'Leadership Tech', 'Standards & Qualité'],
    philosophie: 'La créativité inspire. La stratégie dirige. Mais c\'est l\'excellence technique qui livre. PRIsME doit être brillant ET solide.'
  }
];

export const synergieTOP3 = {
  titre: 'La Trinité PRIsME : Créativité × Stratégie × Excellence',
  description: 'Séparément, chacun est puissant. Ensemble, ils sont imbattables.',
  synergies: [
    {
      lien: 'Dany × Dany',
      description: 'Le créateur visionnaire rencontre le bâtisseur méthodique. Innovation + Exécution = Révolution commerciale.',
      resultat: 'PRIsME passe de "wow c\'est impressionnant" à "on signe 25 clients à 200k$ de revenus"'
    },
    {
      lien: 'Dany × François',
      description: 'La stratégie de croissance rencontre la rigueur technique. Ambition + Solidité = Scalabilité sans compromis.',
      resultat: 'Chaque client reçoit une solution d\'excellence qui scale sans casser'
    },
    {
      lien: 'Dany × François',
      description: 'L\'innovation audacieuse rencontre l\'excellence technique. Créativité + Standards = Solutions industrielles révolutionnaires.',
      resultat: 'Des idées folles deviennent des produits de niveau entreprise'
    }
  ],
  conclusion: 'Dany CRÉE la magie. Dany BÂTIT l\'empire. François GARANTIT l\'excellence. Sans l\'un d\'eux, PRIsME est incomplet. Ensemble, ils changent l\'industrie.'
};

